import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { transformString } from '@/utils';
import {
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import { Link } from '@/components';

export default function BuybackEventsTable() {
  const [data, error] = useApi({
    url: '/treasury/events/',
    queryParams: {
      p_size: 10,
      operation: 'buyback'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Event',
        getCell: (row) => {
          if (row.operation === 'transfer') {
            return 'Transfer';
          } else {
            return transformString(row.operation) + ' 🔥';
          }
        },
        columnSize: ['minmax(80px, auto)']
      },
      {
        header: 'From',
        getCell: (row) => (
          <Link to={`/tokens/${row.address}/holders/${row.sender}`}>
            <WalletAddress
              address={row.sender}
              options={{ sizes: { blockie: '0' } }}
            />
          </Link>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'To',
        getCell: (row) => (
          <Link to={`/tokens/${row.address}/holders/${row.receiver}`}>
            <WalletAddress
              address={row.receiver}
              options={{ sizes: { blockie: '0' } }}
            />
          </Link>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Amount',
        getCell: (row) => (
          <CurrencyValue
            value={row.amount}
            options={{
              currency: {
                name: row.symbol,
                address: row.address,
                network: 'ethereum'
              },

              trend: false,
              iconSize: '1'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'order_index'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
      />
    );
  }
  return <TableSkeleton />;
}
